import { FormInput, FormSelect, FormSelectOption } from '@practium/ui';
import { ANALYSIS_UNIT_OPTIONS } from '../../constants/analyses.constants';
import styles from './AnalysisForm.module.css';

interface AnalysisValueInputProps {
	value: string;
	unit: string;
	onValueChange: (value: string) => void;
	onUnitChange: (unit: string) => void;
	hasError?: boolean;
	min?: string;
	max?: string;
	step?: string;
	options?: FormSelectOption[];
}

export const AnalysisValueInput = ({
	value,
	unit,
	onValueChange,
	onUnitChange,
	hasError,
	min = '0',
	max,
	step = '0.01',
	options = ANALYSIS_UNIT_OPTIONS,
}: AnalysisValueInputProps) => {

	return (
		<div className={styles.valueWithUnit}>
			<FormInput
				type="number"
				min={min}
				max={max}
				step={step}
				placeholder={value.trim() ? 'Ex.: 0.00' : 'Não se aplica'}
				value={value}
				onChange={(event) => onValueChange(event.target.value)}
				hasError={hasError}
			/>
			<FormSelect
				value={unit}
				onChange={onUnitChange}
				options={options}
				placeholder="Unidade"
			/>
		</div>
	);
};
